import React from "react";
import "./Loading.css";

function Loading() {
  return (
    <div className="loading">
      <div className="page__initate">
        <img
          className="page__loading"
          src="https://i.pinimg.com/474x/7f/a2/1f/7fa21f763d9528ead80c51e78ff671c2.jpg"
          alt=""
        />
      </div>
    </div>
  );
}

export default Loading;
